import { useState } from "react";
import { siteNav, hotSearch } from "@/mocks/homeData";

export default function TopNav() {
  const [query, setQuery] = useState("");
  const [showTips, setShowTips] = useState(false);

  return (
    <header className="w-full">
      <div className="bg-primary-600 text-background-50">
        <div className="px-4 md:px-8 h-9 flex items-center justify-between text-xs">
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-calendar-line" /> 2026年10月10日 星期六
            </span>
            <span className="hidden sm:inline-flex items-center gap-1.5">
              <i className="ri-fire-line" /> 今日更新 128 个合集
            </span>
          </div>
          <div className="hidden md:flex items-center gap-5">
            <button type="button" className="hover:text-accent-200 cursor-pointer">加入收藏</button>
            <button type="button" className="hover:text-accent-200 cursor-pointer">帮助中心</button>
            <button type="button" className="hover:text-accent-200 cursor-pointer">下载客户端</button>
          </div>
        </div>
      </div>

      <div className="bg-background-50 border-b border-background-200/70">
        <div className="px-4 md:px-8 py-4 flex items-center gap-4 md:gap-8">
          <a href="#top" className="flex items-center gap-3 shrink-0 cursor-pointer">
            <span className="w-11 h-11 rounded-md bg-primary-600 text-background-50 font-heading font-black text-xl flex items-center justify-center">
              91
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-2xl text-foreground-950">91网</span>
              <span className="text-[10px] tracking-[0.22em] text-secondary-600 mt-1">RESOURCE DIGEST</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-2 text-sm text-foreground-600 flex-1">
            <i className="ri-newspaper-line text-lg text-primary-600" />
            <span>热门视频合集与精选内容，一站式帮你找到想看的</span>
          </div>

          <div className="relative ml-auto w-40 sm:w-60 md:w-80">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onFocus={() => setShowTips(true)}
              onBlur={() => setTimeout(() => setShowTips(false), 150)}
              placeholder="搜索合集 / 视频 / 资源"
              className="w-full h-10 pl-9 pr-3 rounded-md border border-background-300/70 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
            {showTips && (
              <div className="absolute left-0 right-0 top-12 z-30 bg-background-50 border border-background-200 rounded-md overflow-hidden">
                <p className="px-3 pt-3 pb-1 text-[11px] text-foreground-500">热门搜索</p>
                <div className="px-3 pb-3 flex flex-wrap gap-2">
                  {hotSearch.map((k) => (
                    <button
                      type="button"
                      key={k}
                      onMouseDown={() => setQuery(k)}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs cursor-pointer hover:bg-secondary-200"
                    >
                      {k}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <a
            href="#download"
            className="hidden sm:inline-flex items-center gap-2 h-10 px-4 rounded-md bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-700"
          >
            <i className="ri-download-2-line text-base" /> 下载客户端
          </a>
        </div>

        <nav className="px-4 md:px-8 border-t border-background-200/60">
          <div className="flex items-center gap-6 h-12 overflow-x-auto no-scrollbar">
            {siteNav.map((item, idx) => (
              <a
                key={item.label}
                href={item.href}
                className={`text-sm whitespace-nowrap cursor-pointer ${
                  idx === 0 ? "text-primary-600 font-semibold" : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {item.label}
              </a>
            ))}
            <span className="ml-auto hidden md:flex items-center gap-2 text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-flashlight-line text-accent-500" /> 正在热播：
              <button type="button" className="text-primary-600 cursor-pointer">年度高分电影合集</button>
            </span>
          </div>
        </nav>
      </div>
    </header>
  );
}